module.exports = __webpack_public_path__ + "img/thumbnail_RedRuffedLemur_f_normal.85287003.png";